// Frontend/src/components/admin/ui/StatusBadge.js

const statusColors = {
  new: 'bg-blue-100 text-blue-800',
  read: 'bg-green-100 text-green-800',
  pending: 'bg-yellow-100 text-yellow-800',
  successful: 'bg-green-100 text-green-800',
  failed: 'bg-red-100 text-red-800',
  default: 'bg-gray-100 text-gray-800'
};

const StatusBadge = ({ status }) => {
  const colorClass = statusColors[status] || statusColors.default;
  const displayText = status ? status.charAt(0).toUpperCase() + status.slice(1) : 'Unknown';

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass}`}>
      {displayText}
    </span>
  );
};

export default StatusBadge;